import { StateCreator, create } from "zustand"
import { getBusinessUserInfo } from "@/apis/crypto"
import { Toast } from "antd-mobile"

interface Arrobj{
    range_start:string,
    range_end:string,
    subsidy_ratio:string
}

export type CryptoMerchantInfo = {
    userId: number,
    interestSettlement: string,
    businessAssureBalance: string,
    businessBalance: string,
    level: {
        matchingLevel: null,
        feeRate: number,
        userId: number,
    },
    professionLevel:{
        feeRate:number,
        // fixedAmount:string,
        fixedAmount:{
            bankCard: Arrobj[],
            wechatAlipay: Arrobj[],
        }
        matchingLevel: string,
    },
    yesterday:{
        business_subsidy_balance_count:string,
    },
    month:{
        business_subsidy_balance_count:string,
    }
}
type CryptoMerchantState = {
    cryptoMerchantInfo: CryptoMerchantInfo
}

type CryptoMerchantActions = {
    getCryptoMerchantInfo: () => void
}

type CryptoMerchantStore = CryptoMerchantState & CryptoMerchantActions

export const initStore: StateCreator<CryptoMerchantStore> = (set, get) => {
    const getCryptoMerchantInfo = async () => {
        const { ok, data, msg } = await getBusinessUserInfo();
        if (ok) {
            set({ cryptoMerchantInfo: data });
        } else {
            Toast.show(msg);
        }
        return ok;
    }
    return {
        cryptoMerchantInfo: {
            userId: 0,
            interestSettlement: "0.0000",
            businessAssureBalance: "0.0000",
            businessBalance: "0.0000",
            level: {
                matchingLevel: null,
                feeRate: 0,
                userId: 0,
            },
            professionLevel:{
                feeRate:0,
                // fixedAmount:"",
                fixedAmount:{
                    bankCard: [],
                    wechatAlipay: []
                },
                matchingLevel: "",
            },
            yesterday:{
                business_subsidy_balance_count:"",
            },
            month:{
                business_subsidy_balance_count:"",
            }
        },
        getCryptoMerchantInfo
    }
}

export const useCryptoMerchantInfoStore = create<CryptoMerchantStore>(initStore);